// extracted by mini-css-extract-plugin
export var divider = "_nm-0";
export var systemMessage = "_nm-1";
export var systemMessageWrapper = "_nm-2";